import '../assets/main.css'
import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
// Nuxt UI's Vue plugin (NOT the Nuxt module) — provides toasts/overlays/theme
import ui from '@nuxt/ui/vue-plugin'
import Layout from '../components/Layout.vue'

// Inertia <-> Vue mount: Rails controllers respond with a page name
// ("Assets/Index") + props; we resolve that name to a .vue file here and Vue
// mounts onto the <div id="app" data-page="…"> that inertia_rails rendered.
createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.vue', { eager: true })
    const page = pages[`../pages/${name}.vue`]
    page.default.layout ??= Layout
    return page
  },
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(ui)
      .mount(el)
  },
})
